/**
 * UNBEGUN Personalizer template configuration â€” Build 15
 *
 * Change only the values below when a complete product category needs a
 * different preview position. Values are percentages of the square preview.
 *
 * x: horizontal position (0 = left, 100 = right)
 * y: vertical position   (0 = top, 100 = bottom)
 * fontScale: responsive letter size in cqi
 */
window.UNBEGUN_PERSONALIZER_TEMPLATES = Object.freeze({
  neo: Object.freeze({
    x: 50,
    y: 34.1,
    fontScale: 2.15
  }),

  ipad: Object.freeze({
    x: 50,
    y: 31,
    fontScale: 2.15
  }),

  // Standard laptop sleeves. Start with the proven Neo placement;
  // adjust only this block if the regular laptop photography needs it.
  laptop: Object.freeze({
    x: 50,
    y: 32,
    fontScale: 2.15
  })
});

(() => {
  function applyTemplatePositions() {
    const templates = window.UNBEGUN_PERSONALIZER_TEMPLATES || {};

    document.querySelectorAll('[data-unbegun-personalizer]').forEach(root => {
      const templateName = root.dataset.personalizerTemplate || 'neo';
      const template = templates[templateName] || templates.neo;
      const imageWrap = root.querySelector('.unbegun-personalizer__image-wrap');

      if (!template || !imageWrap) return;

      imageWrap.style.setProperty('--unbegun-personalizer-x', `${Number(template.x)}%`);
      imageWrap.style.setProperty('--unbegun-personalizer-y', `${Number(template.y)}%`);
      imageWrap.style.setProperty('--unbegun-personalizer-font-scale', `${Number(template.fontScale)}cqi`);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyTemplatePositions, { once: true });
  } else {
    applyTemplatePositions();
  }

  document.addEventListener('shopify:section:load', applyTemplatePositions);
  window.UnbegunApplyPersonalizerTemplates = applyTemplatePositions;
})();